import React from 'react';
import { Container } from '@material-ui/core';

import css from './Types.module.css';

import aqavitalImg from '../../assets/images/aquavital.png';

import Title from '../UI/Title/Title';
import Type from './Type/Type';
import Button from '../UI/Button/Button';

const Types = (props) => (
    <div className={css.Types}>
        <Title>{props.title}</Title>
        <Container>
            <img src={aqavitalImg} alt="aquavitalImage" />
            <br />
            <br />
            <Type title="Typ 1" zoll="1/4“ - 3/8”" mm="5 - 14" />
            <Type title="Typ 2" zoll="1/2“ - 3/4”" mm="16 - 27" />
            <Type title="Typ 3" zoll="1/2“ - 3/4”" mm="16 - 27">
                <br />
                Ovaj je uređaj izrađen po mjeri za glavne vodovode s promjerom cijevi od 1/2“ Zolla.
                Budući da bi Typ 2 imao premali učinak, a Typ 4 bio prevelik, za ovu situaciju preporučujemo Typ 3.<br />
                <br />
            </Type>
            <Type title="Typ 4 - Idealan za vašu obiteljsku kuću" zoll="3/4“ - 5/4”" mm="28 - 42" />
            <Type title="Typ 5" zoll="1 1/2“ - 2”" mm="43 - 62" />
            <Type title="Typ 6" zoll="3“ - 4”" mm="63 - 115" />
            <Button path="/kontakt">
                NARUČITE SADA
            </Button>
            <br />
        </Container>
    </div>
);

export default Types;